import { useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { ListCustomersUseCase } from "../../../Usecase/Customers/list-customers-usecase";
import { ICustomerEntity } from "../../../Services/api/customers/customers.interface";
import { DestroyCustomersUseCase } from "../../../Usecase/Customers/destroy-customers-usecase";
import { maskPhone } from "../../../utils/maskPhone";


interface IUseListCustomersProps {
  listCustomersUseCase: ListCustomersUseCase
  destroyCustomersUseCase: DestroyCustomersUseCase
}
export function useListCustomers({ listCustomersUseCase, destroyCustomersUseCase }: IUseListCustomersProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<ICustomerEntity[]>([])
    const [boxToDestroy, setCustomerToDestroy] = useState('')
    const [totalRegisters, setTotalRegisters] = useState(1)
   
    const { showToast } =  useToast()

    const loadCustomers = async ({ page: currentPage, searchBy }: any) => {
        
      try {
        setLoading(true)
        
        const listResult = await listCustomersUseCase.handle({ page: currentPage, searchBy});

        if (listResult.isFailure) {
     
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

       const list = listResult.getValue()

     
       setData(list?.data || [])
       setTotalRegisters(list?.total || 0)
       

  
       setPage(currentPage)
      } catch (error) {
        console.log("error listCustomers function: ", error)
      } finally {
        setLoading(false);
      }
  };

    const list = useMemo(() => {
        const rows = data?.map(customer => {
            return {
                id: customer.id,
                name: customer.name,
                document: customer.document,
                email: customer.email,
                stateRegistration: customer.stateRegistration,
                phone: customer?.phone ? maskPhone(customer?.phone) : '',
            }
        })

        return rows
    }, [data])

    const handleDestroyCustomer = async () => {
        
      try {
        setLoading(true)
        
        const destroyResult = await destroyCustomersUseCase.handle(boxToDestroy);

        if (destroyResult.isFailure) {
     
          showToast(String(destroyResult?.error?.error), 'error');
          return;
        }

        setCustomerToDestroy('')
        showToast('Removido com sucesso.', 'success');

       await loadCustomers({ page: 1})
      } catch (error) {
        console.log("error destroyCustomers function: ", error)
      } finally {
        setLoading(false);
      }
    };

      

    return {
        loading,
        loadCustomers,
        list,
        data,
        setCustomerToDestroy,
        boxToDestroy,
        handleDestroyCustomer,
        totalRegisters
        
    }
}